module.exports = __webpack_public_path__ + "img/loading-item-processing@3x.2fe9d733.png";